import { connect } from "react-redux";

import StockOrders from "./stockOrders";
import {
  getProductsStatus,
  getProductsData,
  getIsStockOrder,
  getItemCommentsData,
  getItemCommentsStatus,
} from "../../store/selectors";
import { getCartData } from "../../../orderBuilder/store/selectors";
import {
  loadProducts,
  setIsStockOrder,
  loadItemComments,
} from "../../store/action-creators";
import { addOrderToCart } from "../../../orderBuilder/store/action-creators";
import { getProfileData } from "../../../login/store/selectors";

const mapStateToProps = (state) => ({
  productsStatus: getProductsStatus(state),
  productsData: getProductsData(state),
  itemCommentsStatus: getItemCommentsStatus(state),
  itemCommentsData: getItemCommentsData(state),
  cartData: getCartData(state),
  profileData: getProfileData(state),
  isStockOrder: getIsStockOrder(state),
});

const mapDispatchToProps = {
  loadProducts,
  loadItemComments,
  addOrderToCart,
  setIsStockOrder,
};

export default connect(mapStateToProps, mapDispatchToProps)(StockOrders);
